import { render, staticRenderFns } from "./ProgramInfo.vue?vue&type=template&id=fbecc58e&scoped=true"
import script from "./ProgramInfo.vue?vue&type=script&lang=js"
export * from "./ProgramInfo.vue?vue&type=script&lang=js"
import style0 from "./ProgramInfo.vue?vue&type=style&index=0&id=fbecc58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbecc58e",
  null
  
)

export default component.exports